import React, {useEffect, useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/png/logo_xerius.png"
import illustration1 from "components/../assets/svg/group59Copy.svg"
import illustration2 from "components/../assets/png/confirmation_icon.png"
import illustration3 from "components/../assets/png/xerius-error.png"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { BASE_URL } from '../../../env';
import Fade from "@material-ui/core/Fade";
import { AiOutlineWarning } from 'react-icons/ai';
import { useHistory } from "react-router-dom";
import deleteCookie from '../../../functions/deleteCookie';
import { AppDataContext } from '../../../contexts/app-data';


const NotifOverlay = () => {
  const [hideOverlay, setHideOverlay] = useState(false)
  useEffect(() => {
    setTimeout(function () {
      setHideOverlay(true)
    }, 1200)
  }, [])

  return (
 <>
    <div className={hideOverlay ? "nitification-overlay off" : "nitification-overlay" }>
      <div className="wrapper">
    <BaseParagraph  illustration={illustration1} >
          <p>{t('pro_infos.pro_info_popup_data_sent.text')}</p>
     </BaseParagraph>
      </div>
    </div>
  </>
  )
}

const TextBody = ({withXerius, email}) => {
  const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`
  const fetch_POST_init_options = {
    method: 'POST',
    credentials: "include",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',            
    }
  }
  const fetch_GET_init_options = {
    method: 'GET',
    credentials: "include",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',            
    }
  }
  const dynamicText = (TEXT, INSERT, SELECTOR) => TEXT.replace(SELECTOR, INSERT)
  return (
   <>
     <div style={{textAlign: "center"}}>
      { (withXerius && withXerius === "error") ? 
        <h3> {t('pro_infos.pro_info_confirmation.title2')}</h3>
        : <h3> {t('pro_infos.pro_info_confirmation.title1')}</h3>
      }
        <p dangerouslySetInnerHTML={{__html: dynamicText(t('pro_infos.pro_info_confirmation.text1'), `<span class="data-cs-mask" data-cs-mask>${email}</span>`, "####lnk_EmailAddress###")}}></p>
        
      {withXerius && withXerius === "error" &&
            <div className="highlight_block" style={{textAlign: "left"}}>
              <div className="highlight_block__icon">

              <AiOutlineWarning />
              </div>
              <p className="highlight_block__message">
                <span className="highlight_block__title">
                  {t('pro_infos.pro_info_confirmation.xerius_error.title')}
                </span>
                <span className="highlight_block__body" dangerouslySetInnerHTML={
                  {__html: t('pro_infos.pro_info_confirmation.xerius_error.text')}
                  }>
                  </span>
              </p>
            </div>
      }
      <p>{t('pro_infos.pro_info_confirmation.text2')}</p>
     </div>

     <div className="highllight-bloc">
       <h3> {t('pro_infos.pro_info_confirmation.list_title')}</h3>
       {withXerius && (withXerius === "no" || withXerius === "error") && <p>{t('pro_infos.pro_info_confirmation.list_text2')}</p>}
      <p>{t('pro_infos.pro_info_confirmation.list_text1')}</p>
       
      <ul>
          <li>{t('pro_infos.pro_info_confirmation.list.1')}</li>
          <li>{t('pro_infos.pro_info_confirmation.list.2')}</li>
          <li>{t('pro_infos.pro_info_confirmation.list.3')}</li>
      </ul>
    </div>
    </>
  )
}

const Confirmation = () => {
  const lang = localStorage.getItem('language')
  const urlParams = new URLSearchParams(window.location.search);
  const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1`
    

  const fetch_GET_init_options = {
      method: 'GET',
      credentials: "include",
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',            
      }
  }

  const [correlationID, setCorrelationID] = useState('')
  const [email, setEmail] = useState("")
  const [language, setLanguage] = useState("")
  const [withXerius, setWithXerius] = useState('')
  const [hasEnterprise, setHasEnterprise] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [endLoading, setEndLoading] = useState(false)
  const [nextTick, setNextTick] = useState(false)
  const [showNotif, setShowNotif] = useState(false)
  
  useEffect(() => {
    proccessURL()
  

    const timeout= 300
    setTimeout(() => {
      setIsLoading(false)
    }, timeout);
    setEndLoading(true)

       if (window.PageBus) {
          window.PageBus.publish("analyticsServices", {
              pageID: "onboarding",
              stepSeq: "4",
              stepName: "completion:request with success",
              flowType: "sales",
              flowName: "onboarding",
              productName: "onboarding",
              trackMethod: "flow"
            }
          );
      }

    return function cleanup() {
      setEndLoading(false)
    };
  }, [])

  useEffect(() => {
    if(email !== "") deleteCookie()
  }, [email])

  useEffect(() => {
    if (hasEnterprise === "ok") deleteCookie()
  }, [hasEnterprise])

  useEffect(() => {
    if (nextTick) getData(urlParams.has('correID'))
    if (((withXerius && withXerius === "no") || (!withXerius && !hasEnterprise && !correlationID)) && (!localStorage.getItem('dataSent') || localStorage.getItem('dataSent') === "0")) {
      setShowNotif(true)
      localStorage.setItem('dataSent', "1")
    }

  }, [nextTick])

  async function getData(hascorreID) {
    if (hascorreID) {
      console.log('hascorreID')
      console.log(correlationID)
      const payload = await (await fetch(`${base_URL}/payload/${correlationID}`, fetch_GET_init_options)).json()
      // setLanguage(payload.language)
      // localStorage.setItem('language', payload.language)
      setEmail(payload.email)

    } else {
      console.log('not hascorreID')
      const hasEnterprise = await (await fetch(`${base_URL}/step/has_enterprise`, fetch_GET_init_options)).json()
      const email = await (await fetch(`${base_URL}/step/email`, fetch_GET_init_options)).json()
      const language = await (await fetch(`${base_URL}/step/language`, fetch_GET_init_options)).json()
      setEmail(email.fieldValue)
      setLanguage(language.fieldValue)
    }
  }

  const proccessURL = () => {
    urlParams.has('correID') && setCorrelationID(urlParams.get('correID'))
    urlParams.has('xerius') && setWithXerius(urlParams.get('xerius'))
    urlParams.has('enterprise') && setHasEnterprise(urlParams.get('enterprise'))
    setNextTick(true)
  }


  const reset = () => {
    console.log(process.env.REACT_APP_ENV)
    if (process.env.REACT_APP_ENV === "qa") {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
    } else if (process.env.REACT_APP_ENV === "prod") {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.hellobank.be/fr/public/accueil" : "https://pro.hellobank.be/nl/public/startpagina")
    } else {
      deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
    }
    
  }
    const { state, dispatch } = React.useContext(AppDataContext)

  return (
      <div className={"confirmation"}>
        {showNotif && < NotifOverlay />}
        {/* <StepsWrapper stepGroupTitle={t('general.register_your_enterprise')} title={t('general.open_pro_account')}> */}
        <StepsWrapper stepGroupTitle={' '} >
          <StepsLoader loading={isLoading}>
            <Fade in={endLoading} timeout={{ enter: 300, exit: 1200 }} >
            <div>
              {withXerius && withXerius === "error" ?
                  <BaseParagraph  illustration={illustration3} />
                  : <BaseParagraph  illustration={illustration2} /> }
                  <BaseParagraph   >
                <TextBody withXerius={withXerius} email={ email}/>
                  </BaseParagraph>
                  <div className={"footer-action"} style={{bottom: state.footer_height}}>
                    <BaseButton caption={t('pro_infos.pro_info_confirmation.cta')} action={reset}/>
                  </div>
              </div>
            </Fade>
          </StepsLoader>
        </StepsWrapper>
      </div>
    )
}

Confirmation.propTypes = {
    name: PropTypes.string
}

Confirmation.defaultProps = {
    name: "Step02"
}


export default Confirmation